import { platformDisclaimerContent } from '@/config/marketing-content/legal-pages'
import { LegalDocumentLayout } from '@/components/marketing/legal-document-layout'

export function PlatformDisclaimerPage() {
  return <LegalDocumentLayout document={platformDisclaimerContent} />
}
